import Cookies from 'js-cookie'
const TokenKey = 'access_token'

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    let expires = new Date(new Date() * 1 + 1000 * 60 * 60 * 10);
    return Cookies.set(TokenKey, token, { expires: expires });
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}
